import { skipToken } from '@tanstack/react-query'
import { getAddress, isAddress } from 'viem'

import type { UserEarnPositions } from '@/lib/procedures/userPositions.contract'

import { orpc } from '@/lib/orpc/client'

export type UserEarnPosition = UserEarnPositions['items'][number]
export type UserEarnPositionFacets = UserEarnPositions['facets']

/**
 * The query every earn-positions reader shares: the Portfolio hero and table, the Portfolio nav
 * badge and the vault table's position column, plus the vault table's server prefetch. One key per
 * user, with the address checksummed so a URL address and the wallet's share it. No order is sent:
 * the procedure returns every position and the table sorts on the client.
 */
export function userEarnPositionsQueryOptions(userAddress: string | undefined) {
  return orpc.user.earnPositions.queryOptions({
    input:
      userAddress && isAddress(userAddress, { strict: false })
        ? { userAddress: getAddress(userAddress) }
        : skipToken,
    staleTime: 60 * 1000
  })
}
